"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Title() {
    return (react_1.default.createElement("div", { id: "title" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("h1", null, "FYRE 5480"),
            react_1.default.createElement("p", null, "FRC team based in Reno, Nevada")),
        react_1.default.createElement("img", { src: "./711ebe8d03035220e9db.svg" })));
}
exports.default = Title;
